import styled from 'styled-components';

export const Container = styled.div<{ name: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  border-right: 1px solid white;
  border-bottom: 1px solid white;
`;

export const LineMarkY = styled.div`
  height: 50%;
  width: 0.4vw;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
`;

export const LineMarkX = styled.div`
  height: 0.4vw;
  width: 50%;
  border-left: 1px solid white;
  border-right: 1px solid white;
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
